import React, { Fragment } from 'react'
import { Card, Col, Container, Form, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import {formato_rut, isValidParam} from '../../../common/Formatos'

const Propietario = ({formik,setRutPropietarioFinal}) => {
  const data_datos_generales = useSelector((state) => state.casoGeneralReducer)
  const { cfg_form_implicado } = data_datos_generales
  const data_datos_implicado = useSelector((state) => state.implicadoReducer)
  const { datosPantalla} = data_datos_implicado

  return (
      <>
      {/* <Container> */}
    <Card className='mt-1 '>
      <Card.Header className='mt-0 mb-0' as='h6' style={{backgroundColor:"#D9EDF6", color:"#8578CD"}}>
        {cfg_form_implicado ? cfg_form_implicado.cfg_form_implicado['gestcasosrecup-editimpl-title-tabprop'] : null}
      </Card.Header>
      <Container>
        {cfg_form_implicado ? (
          <div>
            <Row>
              <Col>
                <Form.Label
                  className='mb-0'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form_implicado.cfg_form_implicado['gestcasosrecup-editimpl-rutprop']}
                </Form.Label>{' '}
                <br />
                <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosPantalla && datosPantalla.length !== 'undefined'
                        ? datosPantalla.datosPantalla[0]['RutPropietario']
                        : ""}
                    </Form.Text>
              </Col>
              <Col>
                <Form.Label
                  className=' mb-0'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form_implicado.cfg_form_implicado['gestcasosrecup-editimpl-nomprop']}
                </Form.Label>
                <br />
                <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosPantalla && datosPantalla.length !== 'undefined'
                        ? datosPantalla.datosPantalla[0]['NombrePropietario']
                        : ""}
                    </Form.Text>
              </Col>
              <Col>
                <Form.Label
                  className='mb-0'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form_implicado.cfg_form_implicado['gestcasosrecup-editimpl-dirprop']}
                </Form.Label>
                <br />
                <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosPantalla && datosPantalla.length !== 'undefined'
                        ? datosPantalla.datosPantalla[0]['DireccionPropietario']
                        : ""}
                    </Form.Text>
              </Col>

              <Col>
                <Form.Label
                  className='mb-0'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form_implicado.cfg_form_implicado['gestcasosrecup-editimpl-emailprop']}
                </Form.Label>
                <br />
                <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosPantalla && datosPantalla.length !== 'undefined'
                        ? datosPantalla.datosPantalla[0]['EmailPropietario']
                        : ""}
                    </Form.Text>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Label
                  className='mt-3 mb-0'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form_implicado.cfg_form_implicado['gestcasosrecup-editimpl-fonoprop']}
                </Form.Label>
                <br />
                <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosPantalla && isValidParam(datosPantalla.datosPantalla[0]['paisFonoPropietario'])
                        ? (datosPantalla.datosPantalla[0]['paisFonoPropietario'])+" "+datosPantalla.datosPantalla[0]['FonoPropietario']
                        : ""}
                    </Form.Text>
              </Col>
              <Col>
                <Form.Label
                  className='mt-3 mb-0'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form_implicado.cfg_form_implicado['gestcasosrecup-editimpl-movilprop']}
                </Form.Label>
                <br />
                <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosPantalla && isValidParam(datosPantalla.datosPantalla[0]['paisMovilPropietario'])
                        ? (datosPantalla.datosPantalla[0]['paisMovilPropietario'])+" "+datosPantalla.datosPantalla[0]['MovilPropietario']
                        : ""}
                    </Form.Text>
                  
              </Col>

              <Col>
                <Form.Label
                  className='mt-3 mb-0'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form_implicado.cfg_form_implicado['gestcasosrecup-editimpl-comunaprop']}
                </Form.Label>
                <br />
                <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosPantalla && datosPantalla.length !== 'undefined'
                        ? datosPantalla.datosPantalla[0]['ComunaPropietario']
                        : ""}
                    </Form.Text>
              </Col>
              <Col>
                <Form.Label
                  className='mt-3 mb-0'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form_implicado.cfg_form_implicado['gestcasosrecup-editimpl-ciudadprop']}
                </Form.Label>
                <br />
                <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosPantalla && datosPantalla.length !== 'undefined'
                        ? datosPantalla.datosPantalla[0]['CiudadPropietario']
                        : ""}
                    </Form.Text>
              </Col>
            </Row>
            <Row>
              <Col>
                  <Form.Label className=' mb-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                  {cfg_form_implicado.cfg_form_implicado['gestcasosrecup-editimpl-obsprop'] ? cfg_form_implicado.cfg_form_implicado['gestcasosrecup-editimpl-obsprop'] : "Observaciones"}
                  </Form.Label>
                  <br />
                  <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosPantalla && isValidParam(datosPantalla.datosPantalla[0]['obsPropietario'])
                        ? (datosPantalla.datosPantalla[0]['obsPropietario'])
                        : ""}
                    </Form.Text>
                </Col>
              </Row>
          </div>
        ) : null}
      </Container>
    </Card>


    </>
  )
}

export default Propietario
